import { CutOffTime } from './CutOffTime';

export default CutOffTime;